import SubscriptionRequestsService from '../../services/SubscriptionRequestsService';

export async function getVnets(id: number) {
    
    let vNets = JSON.parse(sessionStorage.getItem(id.toString()));
    if (vNets == null) {        
        vNets = await new SubscriptionRequestsService().getAddressSpaces(id);
        sessionStorage.setItem(id.toString(), JSON.stringify(vNets));
    }
    return vNets;
}
